export const PRACTITIONERS_ROLES = {
  admin: '店舗管理',
  clerk: '事務', // 未使用
  company_admin: '本部管理',
  pharmacist: '服薬指導',
} as const;
